import { connect } from "react-redux";
import ValetSalary from './ValetSalary';
import { bindActionCreators } from "redux";
import {getInfraIDForValet, markHolidaysForValet} from "../../../services/redux/Valet/Project/action";
const mapStateToProps = (state) => ({
    InfraIdList : state.CreateProject.InfraIdList,
    valetHolidaysMark: state.CreateProject.valetHolidaysMark
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getInfraIDForValet,
        markHolidaysForValet
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ValetSalary);